/**************************************************************************************************
 *
 *       @file ./auth-landing-root-view.tsx
 *
 *       Container component for top-level layout of page
 *       Passes auth-panel, footer & info-panel into correct slots of auth-landing-root-view
 *
 */

/************************************** THIRD-PARTY IMPORTS ***************************************/
import React from 'react';
import {inject} from 'mobx-react';

import {AuthLandingRootView} from './auth-landing-root-view';
import {AuthLandingFooter} from './footer/auth-landing-footer';
import {AuthPanelRouter} from './auth-landing-router';
import {InfoPanel} from './info-panel/info-panel';


/**************************************** TYPE DEFINITIONS ****************************************/
interface AuthLandingRootContainerProps {}

/********************************************* EXPORT *********************************************/
/**
 *  Wraps the main page
 *  Passes components down to required sections of layout
 */
export class AuthLandingRootContainer extends React.Component<AuthLandingRootContainerProps> {
    render() {
        return (
            <AuthLandingRootView
                infoPanel={<InfoPanel />}
                authPanel={<AuthPanelRouter />}
                footer={<AuthLandingFooter />}
            />
        );
    }
}
